import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslocoService } from "@ngneat/transloco";
import { GeneralService } from "app/services/general.service";
import { COUNTRY_PHONE_CODES } from "app/shared/countries";
import { countries } from "app/shared/countries copy";
import { Country } from "app/shared/countriesClass";
import { timeZoneToCountryCode } from "app/shared/timeZone";
import { Subscription } from "rxjs";

@Component({
  selector: "app-send-offer-req",
  templateUrl: "./send-offer-req.component.html",
  styleUrls: ["./send-offer-req.component.scss"],
})
export class SendOfferReqComponent implements OnInit, OnDestroy {
  @Input() machineId: string;
  @Input() machineName: string;
  contactForm: FormGroup;
  viewRecieveMessage: boolean = false;
  activeLang: string = "EN";
  isSubmitting: boolean = false;
  selectedCountryIso = "tr";
  countries: Country[] = countries;
  timeZoneToCountries: any = timeZoneToCountryCode;
  isBrowser: boolean;
  private langChangesSubscription: Subscription;
  formErrors = {
    email: "",
    phoneNumber: "",
    country: "",
    companyName: "",
    prefix: "",
  };
  validationMessages = {
    companyName: {
      required: "Company Name is required.",
      minlength: "Company Name must be at least 2 characters long.",
    },
    email: {
      required: "Email is required.",
      email: "Please enter a valid email address.",
    },
    phoneNumber: {
      required: "Phone Number is required.",
    },
    country: {
      required: "Country is required.",
    },
    prefix: {
      required: "Required.",
    },
  };

  constructor(
    private fb: FormBuilder,
    private generalServices: GeneralService,
    private _translocoService: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;

    this.getUserCountry();
    this.getActiveLang();
  }

  getActiveLang() {
    this.langChangesSubscription =
      this._translocoService.langChanges$.subscribe((activeLang) => {
        this.activeLang = activeLang;
      });
  }
  getUserCountry() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const countryCode = this.timeZoneToCountries[timeZone];
    this.selectedCountryIso = countryCode || "tr";
    this.createForm();
  }
  createForm() {
    this.contactForm = this.fb.group({
      companyName: ["", [Validators.required, Validators.minLength(2)]],
      country: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      phoneNumber: ["", Validators.required],
      prefix: [""],
      howReachUs: [""],
    });
    this.changeCountryCode();
    this.contactForm.valueChanges.subscribe((data) =>
      this.onValueChanged(data)
    );
    this.onValueChanged(); // Reset validation messages now
  }

  changeCountryCode() {
    const country: Country = this.getCountryByIso(this.selectedCountryIso);
    if (country) {
      this.contactForm.get("prefix").setValue(country.code);
      this.contactForm.get("country").setValue(country.name);
    }
  }

  setCountry(country: Country) {
    this.selectedCountryIso = country.iso;
    this.contactForm.get("prefix").setValue(country.code);
    this.contactForm.get("country").setValue(country.name);
  }

  getCountryByIso(iso: string): Country {
    return this.countries.find((country) => country.iso === iso);
  }

  trackByFn(index: number, item: Country) {
    return item.iso;
  }

  setPhoneCode(phoneCode: string) {
    const prefixControl = this.contactForm.get("prefix");
    if (prefixControl) {
      prefixControl.setValue(phoneCode);
    }
  }

  onValueChanged(data?: any) {
    if (!this.contactForm) {
      return;
    }
    const form = this.contactForm;
    for (const field in this.formErrors) {
      this.formErrors[field] = "";
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          if (control.errors.hasOwnProperty(key)) {
            this.formErrors[field] += messages[key] + " ";
          }
        }
      }
    }
  }

  onSubmit() {
    if (this.contactForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      const form = {
        ...this.contactForm.value,
        machineId: this.machineId,
        machineName: this.machineName,
      };
      this.generalServices.addItem("productForm", form).subscribe(
        () => {
          this.viewRecieveMessage = true;
          this.contactForm.reset();
          this.isSubmitting = false;
        },
        (error) => {
          this.isSubmitting = false;
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.langChangesSubscription) {
      this.langChangesSubscription.unsubscribe();
    }
  }
}
